var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvalBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 96,
    viewBox: "0 0 400 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1244_98253)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.7098,
    cy: -163.968,
    rx: 240.977,
    ry: 175.823,
    transform: "rotate(-7.04001 95.7098 -163.968)",
    fill: "#C6FCA6",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1244_98253",
    x: -226.436,
    y: -422.976,
    width: 644.289,
    height: 518.015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41,
    result: "effect1_foregroundBlur_1244_98253"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalBlur);
export default __webpack_public_path__ + "static/media/oval-blur.0cbcbb14dab078898ef686973a7057c3.svg";
export { ForwardRef as ReactComponent };